module.exports = __webpack_public_path__ + "static/wedo_architecture-3072d9cb097c64fa4c11ecdf3d8abf43.svg";